<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black bg-opacity-50" @click="$emit('close')" />
    <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
      <div class="flex items-center mb-4">
        <svg class="w-8 h-8 text-amber-500 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
        <h3 class="text-lg font-semibold text-gray-900">
          Adresse email manquante
        </h3>
      </div>
      <p class="text-sm text-gray-600 mb-6">
        Veuillez remplir votre adresse mail dans votre Profil pour accéder à toutes les fonctionnalités de Lisaprint.
      </p>
      <div class="flex justify-end space-x-3">
        <button
          class="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
          @click="$emit('close')"
        >
          Plus tard
        </button>
        <button
          class="px-4 py-2 bg-red-700 text-white text-sm font-medium rounded-lg hover:bg-red-800 transition-colors"
          @click="goToProfile"
        >
          Aller au profil
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const router = useRouter();

const goToProfile = () => {
  emit('close');
  router.push('/profile');
};
</script>
